import React from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'Text';

export interface TextProps<T extends React.ElementType> {
	base?: boolean; // font-weight
	center?: boolean;
	crop?: boolean;
	children: React.ReactNode;
	className?: string;
	colorBase?: boolean;
	colorError?: boolean;
	colorExtraLight?: boolean;
	colorDark?: boolean;
	colorDarken?: boolean;
	colorInverted?: boolean;
	colorLight?: boolean;
	colorLighten?: boolean;
	colorLightGray?: boolean;
	colorPrimary?: boolean;
	colorSecondary?: boolean;
	colorSuccess?: boolean;
	colorWarning?: boolean;
	component?: T;
	justify?: boolean;
	left?: boolean;
	lg?: boolean;
	md?: boolean;
	mobBase?: boolean;
	mobLg?: boolean;
	mobMd?: boolean;
	mobSm?: boolean;
	mobStrong?: boolean;
	mobXxxl?: boolean;
	right?: boolean;
	sm?: boolean;
	strikeThrough?: boolean;
	strong?: boolean;
	stronger?: boolean;
	thin?: boolean;
	uppercase?: boolean;
	wrap?: boolean;
	xs?: boolean;
	xl?: boolean;
	xlg?: boolean;
	xxlg?: boolean;
	xxl?: boolean;
	xxxl?: boolean;
}

function Text<T extends React.ElementType = 'span'>({
	component,
	...props
}: TextProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof TextProps<T>>): JSX.Element {
	const Component = component || 'span';

	const {
		base,
		center,
		crop,
		children,
		className,
		justify,
		left,
		lg,
		md,
		mobBase,
		mobSm,
		mobMd,
		mobLg,
		mobStrong,
		mobXxxl,
		right,
		sm,
		strikeThrough,
		strong,
		stronger,
		thin,
		uppercase,
		wrap,
		xs,
		xl,
		xlg,
		xxlg,
		xxl,
		xxxl,
		colorBase,
		colorError,
		colorExtraLight,
		colorDark,
		colorDarken,
		colorInverted,
		colorLight,
		colorLighten,
		colorLightGray,
		colorPrimary,
		colorSecondary,
		colorSuccess,
		colorWarning,
		...otherProps
	} = props;
	return (
		<Component
			{...otherProps}
			className={bm(
				MODULE_NAME,
				{
					base,
					justify,
					crop,
					lg,
					md,
					mobBase,
					mobLg,
					mobMd,
					mobSm,
					mobXxxl,
					sm,
					mobStrong,
					strikeThrough,
					strong,
					stronger,
					thin,
					uppercase,
					wrap,
					xs,
					xl,
					xlg,
					xxlg,
					xxl,
					xxxl,
				},
				[
					{
						colorBase,
						colorError,
						colorExtraLight,
						colorDark,
						colorDarken,
						colorInverted,
						colorLight,
						colorLighten,
						colorLightGray,
						colorPrimary,
						colorSecondary,
						colorSuccess,
						colorWarning,
						textCenter: center,
						textLeft: left,
						textRight: right,
					},
					className,
				]
			)}
		>
			{children}
		</Component>
	);
}

export default Text;
